import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button } from "@/comn/components";
import { lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";
import { useForm, useFetch, useGrid, usePopup, useStore, useToast, useAuth, useModal, usePage } from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_CNTY_TRDE_RPRT,
    SG_CNTY_TRDE_RPRT,
} from "@/tz/go/egaz/osci/ststcl/lpco/service/OsciStstclSelcService";

export const OSCI0502007Q = (props: any) => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0004", "auth_osci0019"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    // 전체 조회용 기관(OGAZ0037)이면 OGA 선택 가능 !== ==!
    const isAllOga = auth.get("orgCd") === "OGAZ0037";

    const [cntyTrdeRprt, setCntyTrdeRprt] = useState(comnUtils.getGridData([]));
    // ORG LIST
    const [orgCdList, setOrgCdList] = useState([]);
    // ORG LPCO LIST
    const [orgLpcoList, setOrgLpcoList] = useState([]);

    let errmsg: any;

    /*
     * Definition Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Statistics by Search Form !== HSCODE 통계 검색 Form ==!
        cntyTrdeRprt: useForm({
            defaultSchema: SF_CNTY_TRDE_RPRT,
            defaultValues: {
                ...(pgeStore?.form || {
                    // 전체 조회용 기관(OGAZ0037)은 OGA를 공백으로 두어 전체 조회 !== ==!
                    orgCd: auth.get("orgCd") === "OGAZ0037" ? "" : auth.get("orgCd"),
                    orgNm: auth.get("orgCd") === "OGAZ0037" ? "" : auth.get("orgNm"),
                    srchStrtDt: comnUtils.getDate({ m: -1 }),
                    srchEndDt: comnUtils.getDate(),
                }),
            },
        }),
    };

    /*
     * Definition Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        cntyTrdeRprt: useGrid({
            defaultSchema: SG_CNTY_TRDE_RPRT,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getCntyTrdeRprt: useFetch({
            api: (page = grid.cntyTrdeRprt.page) => {
                return APIS.getCntyTrdeRprt(form.cntyTrdeRprt.getValues(), page, grid.cntyTrdeRprt.size);
            },
            enabled: comnUtils.isEmpty(form.cntyTrdeRprt.errors) && form.cntyTrdeRprt.isSubmitted,
            key: [grid.cntyTrdeRprt.page, grid.cntyTrdeRprt.size],
            onSuccess: (data: any) => {
                console.log(data);
                setCntyTrdeRprt(data?.cntyTrdeRprt || []);

                setStore(pgeUid, {
                    form: form.cntyTrdeRprt.getValues(),
                    page: grid.cntyTrdeRprt.page,
                    size: grid.cntyTrdeRprt.size,
                });
            },
            onError: (error) => {
                errmsg =
                    error.response?.data.errorCode == -1
                        ? "msg.osc.00015"
                        : error.response?.data.errorMessage || "msg.osc.00015";

                modal.openModal({
                    content: errmsg,
                });
            },
            showToast: false,
        }),
        getOrgLpcoList: useFetch({
            api: (data) => {
                return lpcoUtils.getOrgLpcoList(data);
            },
            onSuccess: (data) => {
                console.log("getOrgLpcoList onSuccess ", data);
                setOrgLpcoList(data || []);
            },
            onError: () => {},
            showToast: false,
        }),
    };

    const handler = {
        setInit: async () => {
            // !== 기관 목록 ==!
            handler.refreshOrgCdList();

            // 기관 LPCO SELECT 목록
            await fetch.getOrgLpcoList.fetch(auth.get("orgCd"));
        },
        refreshOrgCdList: async () => {
            setOrgCdList((await lpcoUtils.getOrgCdList()) || []);
        },
        refreshOrgLpcoList: async (usrOrgCd: any) => {
            if (usrOrgCd) setOrgLpcoList((await lpcoUtils.getOrgLpcoList(usrOrgCd)) || []);
            else setOrgLpcoList([]);
        },
        getCntyTrdeRprt: () => {
            form.cntyTrdeRprt.handleSubmit((data) => {
                grid.cntyTrdeRprt.setPage(0);
                fetch.getCntyTrdeRprt.fetch(0);
            })();
        },
    };

    useEffect(() => {
        handler.setInit();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.cntyTrdeRprt.schema.orgCd}
                                options={orgCdList}
                                edit={isAllOga}
                                onChange={(v: any) => {
                                    handler.refreshOrgLpcoList(v);
                                }}
                            />
                            <Group.Control {...form.cntyTrdeRprt.schema.srchAppCdNo} options={orgLpcoList} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Label {...form.cntyTrdeRprt.schema.srchDtLb} />
                            <Group.Control {...form.cntyTrdeRprt.schema.srchDtDvn} controlSize={1}></Group.Control>
                            <Group.Control {...form.cntyTrdeRprt.schema.srchDt} controlSize={9}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cntyTrdeRprt.schema.srchCstmOfceCd} />
                            <Group.Control {...form.cntyTrdeRprt.schema.srchHsCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cntyTrdeRprt.schema.srchCntyOrigCd} />
                        </Group.Row>
                        {/* <Group.Row> */}
                        {/* <Group.Control {...form.cntyTrdeRprt.schema.srchAppTpCd} /> */}
                        {/* </Group.Row> */}

                        <Group.Row>
                            <Group.Control {...form.cntyTrdeRprt.schema.srchLpcoSttsCd} />
                            <Group.Control {...form.cntyTrdeRprt.schema.srchTansadSttsCd} />
                        </Group.Row>
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="reset"
                                onClick={() => {
                                    form.cntyTrdeRprt.reset();
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.getCntyTrdeRprt();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="excelDown"
                                onClick={async () => {
                                    const bResult = await form.cntyTrdeRprt.validate();
                                    if (bResult) {
                                        // excel download
                                        lpcoUtils.saveExcelDownload(
                                            BASE.api + "/cnty-trde-rprt/excel-down",
                                            form.cntyTrdeRprt.getValues(),
                                        );
                                    }
                                }}
                            />
                        </Layout.Left>
                    </Layout>

                    <Group.Section>
                        <Grid {...grid.cntyTrdeRprt.grid} data={cntyTrdeRprt} />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
